import { render, staticRenderFns } from "./yf.vue?vue&type=template&id=4dda8caa&scoped=true"
import script from "./yf.vue?vue&type=script&lang=js"
export * from "./yf.vue?vue&type=script&lang=js"
import style0 from "./yf.vue?vue&type=style&index=0&id=4dda8caa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda8caa",
  null
  
)

export default component.exports